(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mood-personalized-mirror"] && !Shopify.designMode) return;
  try {
    
  function initializeMoodMirrors() {
    document.querySelectorAll('[data-mood-mirror]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('form');
      if (!form) return;
      const previewText = (key, value) => { root.querySelectorAll('[data-preview="' + key + '"]').forEach((element) => { element.textContent = value; }); };
      const fieldValue = (name) => form.elements.namedItem('properties[' + name + ']')?.value.trim() || '';
      const cleanProfile = (value) => value.replace(/^@/, '');
      const updatePreview = () => {
        const first = cleanProfile(fieldValue('Premier pseudo Instagram')) || 'votre.pseudo';
        const second = cleanProfile(fieldValue('Deuxième pseudo Instagram'));
        previewText('profile1', first);
        previewText('profile2', second);
        previewText('author', first);
        previewText('time', fieldValue('Heure à afficher') || '06:28');
        previewText('location', fieldValue('Ville ou localisation') || 'Votre localisation');
        previewText('liked', fieldValue('Aimé par') || 'vos.proches');
        previewText('caption', fieldValue('Texte de la publication') || 'Votre message, vos emojis ✨ et vos #hashtags');
        [['likes', 'Nombre de likes', '206 K'], ['comments', 'Nombre de commentaires', '486'], ['reposts', 'Nombre de republications', '1 164'], ['shares', 'Nombre de partages', '29,4 K']].forEach(([key, name, fallback]) => {
          const value = fieldValue(name);
          previewText(key, value && Number.isFinite(Number(value)) ? new Intl.NumberFormat('fr-FR', { notation: Number(value) >= 10000 ? 'compact' : 'standard', maximumFractionDigits: 1 }).format(Number(value)) : fallback);
        });
        root.querySelector('[data-preview-second]').hidden = !second;
        root.querySelector('[data-preview-fiction]').hidden = !fieldValue('Type de référence Aimé par').startsWith('Personnalité publique');
        root.querySelector('[data-avatar-fallback="1"]').textContent = first[0].toUpperCase();
        previewText('date', fieldValue('Date affichée') || 'Il y a 2 jours');
      };
      const updateSize = () => {
        const radio = form.querySelector('input[name="id"]:checked');
        if (!radio) return;
        previewText('size', radio.dataset.size);
        const dimensions = radio.dataset.size.match(/(\d+)\s*[×x]\s*(\d+)/);
        if (!dimensions) return;
        const height = Number(dimensions[1]);
        const width = Number(dimensions[2]);
        const mockup = root.querySelector('[data-mirror-mockup]');
        const availableWidth = Math.max(180, Math.min(320, root.querySelector('.mc-mirror__preview-stage').clientWidth - 16));
        const availableHeight = window.matchMedia('(max-width:899px)').matches ? 400 : 440;
        mockup.style.width = Math.min(availableWidth, availableHeight * width / height) + 'px';
        mockup.style.aspectRatio = width + ' / ' + height;
      };
      form.addEventListener('input', updatePreview);
      form.addEventListener('change', updatePreview);
      updatePreview();
      updateSize();
      window.addEventListener('resize', updateSize);
      root.querySelectorAll('[data-mirror-view]').forEach((button) => {
        button.addEventListener('click', () => {
          root.querySelectorAll('[data-mirror-panel]').forEach((panel) => { panel.hidden = panel.dataset.mirrorPanel !== button.dataset.mirrorView; });
          root.querySelectorAll('[data-mirror-view]').forEach((tab) => { tab.setAttribute('aria-pressed', String(tab === button)); });
          updateSize();
        });
      });
      form.querySelectorAll('input[name="id"]').forEach((radio) => {
        radio.addEventListener('change', () => {
          root.querySelectorAll('[data-mirror-price]').forEach((label) => { label.textContent = radio.dataset.price; });
          updateSize();
        });
      });
      const zoom = root.querySelector('[data-mirror-zoom]');
      zoom?.addEventListener('click', () => {
        const active = root.querySelector('.mc-mirror__photo-wrap').classList.toggle('is-zoomed');
        zoom.setAttribute('aria-pressed', String(active));
        zoom.textContent = active ? 'Vue complète ↙' : 'Voir les détails ↗';
      });
      form.querySelectorAll('[data-mirror-file]').forEach((input) => {
        let previewUrl;
        input.addEventListener('change', () => {
          input.setCustomValidity('');
          const status = input.parentElement.querySelector('[data-file-status]');
          const avatar = input.parentElement.querySelector('img');
          const avatarNumber = '1';
          const liveAvatar = root.querySelector('[data-preview-avatar="' + avatarNumber + '"]');
          const fallbackAvatar = root.querySelector('[data-avatar-fallback="' + avatarNumber + '"]');
          liveAvatar.hidden = true;
          fallbackAvatar.hidden = false;
          avatar.hidden = true;
          if (previewUrl) URL.revokeObjectURL(previewUrl);
          const file = input.files?.[0];
          if (!file) { status.textContent = 'Sélectionnez une photo.'; return; }
          if (file.size > 10 * 1024 * 1024) {
            input.setCustomValidity('Choisissez une photo de 10 Mo maximum.');
            status.textContent = 'Cette photo dépasse 10 Mo. Choisissez un fichier plus léger.';
            input.reportValidity();
            return;
          }
          if (!/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name)) {
            input.setCustomValidity('Choisissez une photo JPG, PNG, WebP ou HEIC.');
            status.textContent = 'Format non accepté. Choisissez une photo JPG, PNG, WebP ou HEIC.';
            input.reportValidity();
            return;
          }
          status.textContent = file.name + ' · Photo sélectionnée';
          previewUrl = URL.createObjectURL(file);
          avatar.onload = () => { avatar.hidden = false; liveAvatar.src = previewUrl; liveAvatar.hidden = false; fallbackAvatar.hidden = true; };
          avatar.onerror = () => { avatar.hidden = true; status.textContent = file.name + ' · Photo sélectionnée (aperçu indisponible)'; };
          avatar.src = previewUrl;
        });
      });
      const submit = form.querySelector('[data-mirror-submit]');
      const error = form.querySelector('[data-mirror-error]');
      submit.disabled = root.hasAttribute('data-mirror-draft-preview');
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (root.hasAttribute('data-mirror-draft-preview')) return;
        if (!form.reportValidity()) return;
        submit.disabled = true;
        const originalText = submit.innerHTML;
        submit.textContent = 'Envoi de votre photo…';
        error.hidden = true;
        try {
          const payload = new FormData(form);
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST', body: payload, headers: { Accept: 'application/json' }
          });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Votre miroir n’a pas pu être ajouté au panier. Veuillez réessayer.');
          window.location.assign(window.Shopify.routes.root + 'cart');
        } catch (exception) {
          error.textContent = exception.message || 'L’envoi a échoué. Vérifiez votre connexion puis réessayez.';
          error.hidden = false;
          submit.disabled = false;
          submit.innerHTML = originalText;
        }
      });
    });
  }
  initializeMoodMirrors();
  document.addEventListener('shopify:section:load', initializeMoodMirrors);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mood-wear-directory"] && !Shopify.designMode) return;
  try {
    
function setupMoodDirectory(){document.querySelectorAll('[data-mc-directory]').forEach(root=>{if(root.dataset.mcReady)return;root.dataset.mcReady='true';const search=root.querySelector('[data-mc-search]');const groups=Array.from(root.querySelectorAll('[data-mc-group]'));const empty=root.querySelector('[data-mc-empty]');const normalize=value=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();search.addEventListener('input',()=>{const query=normalize(search.value.trim());let matches=0;groups.forEach(group=>{const title=normalize(group.querySelector('summary').textContent);const groupMatch=title.includes(query);let links=0;group.querySelectorAll('[data-mc-link]').forEach(link=>{const found=!query||groupMatch||normalize(link.textContent).includes(query);link.hidden=!found;if(found)links++});group.hidden=links===0;group.open=!!query&&links>0;if(!group.hidden)matches++});empty.hidden=matches>0})})}
setupMoodDirectory();
document.addEventListener('shopify:section:load',setupMoodDirectory);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio10-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('studio10-nebula')) {
  class Studio10Nebula extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.canvas = this.querySelector('canvas');
      this.ctx = this.canvas.getContext('2d', { alpha: false });
      if (!this.ctx) return;
      this.button = this.querySelector('button');
      this.buttons = [this.button, ...this.closest('studio10-minimal').querySelectorAll('[data-studio-motion]')];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = true;
      this.time = 0;
      this.abort = new AbortController();
      this.resize = new ResizeObserver(() => this.setup());
      this.resize.observe(this);
      this.intersection = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
      this.intersection.observe(this);
      this.buttons.forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => { this.paused = !this.paused; this.updateButton(); this.schedule(); }, { signal: this.abort.signal });
      });
      this.motion.addEventListener('change', e => { this.paused = e.matches; this.updateButton(); this.schedule(); }, { signal: this.abort.signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal: this.abort.signal });
      this.updateButton(); this.setup();
    }
    updateButton() {
      this.buttons.forEach(button => {
        button.setAttribute('aria-label', this.paused ? button.dataset.resume : button.dataset.pause);
        button.setAttribute('title', this.paused ? button.dataset.resume : button.dataset.pause);
        button.setAttribute('aria-pressed', String(this.paused));
        button.querySelector('span').textContent = this.paused ? '▷' : 'Ⅱ';
      });
    }
    setup() {
      this.w = this.clientWidth; this.h = this.clientHeight;
      if (!this.w || !this.h) return;
      const scale = Math.min(devicePixelRatio || 1, 1.5);
      this.canvas.width = Math.round(this.w * scale); this.canvas.height = Math.round(this.h * scale);
      this.ctx.setTransform(scale, 0, 0, scale, 0, 0);
      let seed = 1024;
      const random = () => { seed = (seed * 1664525 + 1013904223) >>> 0; return seed / 4294967296; };
      const count = this.w < 700 ? 26000 : 48000;
      this.points = Array.from({ length: count }, (_, i) => {
        const gaussian = Math.sqrt(-2 * Math.log(Math.max(.0001, random()))) * Math.cos(random() * Math.PI * 2);
        return { u: random(), band: i % 3, n: gaussian, spread: random() < .3 ? .15 : 1, shift: random() * 2 - 1, size: .45 + random() * 1.05, tone: Math.floor(random() * 4) };
      });
      this.paths = Array.from({ length: 3 }, () => new Float32Array(401 * 4));
      this.draw(); this.schedule();
    }
    schedule() {
      cancelAnimationFrame(this.frame); this.last = 0;
      if (!this.paused && this.visible && !document.hidden && this.isConnected) this.frame = requestAnimationFrame(t => this.tick(t));
    }
    tick(t) {
      if (!this.last || t - this.last >= 32) {
        if (this.last) this.time += Math.min((t - this.last) / 1000, .07);
        this.last = t; this.draw();
      }
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    draw() {
      if (!this.points) return;
      const c = this.ctx, w = this.w, h = this.h, phase = this.time * .13;
      c.fillStyle = '#0b0b0b'; c.fillRect(0, 0, w, h);
      for (let band = 0; band < 3; band++) {
        const path = this.paths[band];
        for (let j = 0; j <= 400; j++) {
          const u = j / 400, a = u * Math.PI * 2;
          let x, y, thickness;
          if (band === 0) {
            x = (u * 1.3 - .15 + .045 * Math.sin(a * 2.1 + phase)) * w;
            y = (.21 + .085 * Math.sin(a * 1.4 + phase) + .065 * Math.sin(a * 3 - phase * .6)) * h;
            thickness = (.006 + .045 * Math.pow(.5 + .5 * Math.sin(a * 1.15 + .8 + phase), 3)) * h;
          } else if (band === 1) {
            x = (u * 1.35 - .18 + .07 * Math.sin(a * 1.6 - phase)) * w;
            y = (.83 + .10 * Math.sin(a * 1.1 - phase + 2) + .05 * Math.sin(a * 2.8 + phase)) * h;
            thickness = (.004 + .033 * Math.pow(.5 + .5 * Math.cos(a * 1.6 + phase), 3)) * h;
          } else {
            x = (.05 + .12 * Math.sin(a + phase * .6) + .07 * Math.sin(a * 2.2 - phase)) * w;
            y = (u * 1.1 - .05) * h;
            thickness = (.003 + .019 * Math.pow(.5 + .5 * Math.sin(a * 1.3 - phase), 2)) * w;
          }
          path[j * 4] = x; path[j * 4 + 1] = y; path[j * 4 + 2] = thickness;
        }
        for (let j = 0; j <= 400; j++) {
          const before = Math.max(0, j - 1) * 4, after = Math.min(400, j + 1) * 4;
          path[j * 4 + 3] = Math.atan2(path[after + 1] - path[before + 1], path[after] - path[before]);
        }
      }
      const colors = ['rgba(155,109,75,.27)','rgba(203,153,110,.45)','rgba(235,195,157,.65)','rgba(255,224,188,.8)'];
      for (let tone = 0; tone < 4; tone++) {
        c.fillStyle = colors[tone];
        for (const p of this.points) {
          if (p.tone !== tone) continue;
          const u = (p.u + this.time * (p.band === 2 ? .005 : .009)) % 1;
          const at = u * 399, index = Math.floor(at) * 4, f = at % 1, path = this.paths[p.band];
          const x = path[index] * (1 - f) + path[index + 4] * f;
          const y = path[index + 1] * (1 - f) + path[index + 5] * f;
          const width = path[index + 2] * (1 - f) + path[index + 6] * f;
          const angle = path[index + 3];
          const offset = p.n * p.spread * width;
          const px = x - Math.sin(angle) * offset + p.shift * 2;
          const py = y + Math.cos(angle) * offset + p.shift;
          c.fillRect(px, py, p.size, p.size);
        }
      }
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.resize?.disconnect(); this.intersection?.disconnect(); this.abort?.abort(); this.ready = false; }
  }
  customElements.define('studio10-nebula', Studio10Nebula);
}
if (!customElements.get('studio10-minimal')) {
  class Studio10Minimal extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.panels = [...this.querySelectorAll('.s10-disclosure')];
      this.querySelectorAll('[data-s10-close]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => this.close(button.closest('details')), options);
      });
      this.panels.forEach(panel => panel.addEventListener('toggle', () => {
        if (panel.open) this.panels.forEach(other => { if (other !== panel) other.open = false; });
      }, options));
      this.querySelectorAll('[data-s10-open]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        const panel = this.panels.find(p => p.id === link.dataset.s10Open);
        if (panel) { this.returnFocus = link; panel.open = true; panel.querySelector('[data-s10-close]').focus(); }
      }, options));
      this.addEventListener('keydown', e => { if (e.key === 'Escape') { const open = this.panels.find(p => p.open); if (open) { e.preventDefault(); this.close(open); } } }, options);
      const feedback = this.querySelector('[data-s10-feedback]');
      if (feedback) { feedback.closest('.s10-disclosure').open = true; feedback.focus(); }
      else if (['#s10-shop', '#s10-shop-clothes'].includes(location.hash)) this.querySelector('#s10-panel-shop').open = true;
      else if (location.hash === '#soins-apres-tatouage') this.querySelector('#s10-panel-aftercare').open = true;
      else if (location.hash === '#s10-studio') this.querySelector('#s10-panel-studio').open = true;
      else if (location.hash === '#s10-contact') this.querySelector('#s10-panel-contact').open = true;
      if (window.Shopify?.designMode) document.addEventListener('shopify:block:select', e => {
        const panel = e.target.closest('.s10-disclosure');
        if (panel && this.contains(panel)) panel.open = true;
      }, options);
    }
    close(panel) { panel.open = false; (this.returnFocus || panel.querySelector('summary')).focus(); this.returnFocus = null; }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  }
  customElements.define('studio10-minimal', Studio10Minimal);
}

if (!customElements.get('studio10-request')) {
  class Studio10Request extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.strings = JSON.parse(this.querySelector('[data-message-strings]').textContent);
      this.fields = [...this.querySelectorAll('[data-field]')];
      this.result = this.querySelector('[data-message-result]');
      this.message = this.querySelector('[data-message]');
      this.status = this.querySelector('[data-copy-status]');
      this.copyButton = this.querySelector('[data-copy]');
      this.generateButton = this.querySelector('[data-generate]');
      this.generateButton.disabled = false;
      this.generateButton.addEventListener('click', () => this.generate(), options);
      this.copyButton.addEventListener('click', () => this.copy(), options);
      this.fields.forEach(field => {
        field.addEventListener('input', () => {
          field.setCustomValidity('');
          if (this.generated) { this.status.textContent = this.strings.stale; this.copyButton.disabled = true; }
        }, options);
        field.addEventListener('change', () => {
          if (this.generated) { this.status.textContent = this.strings.stale; this.copyButton.disabled = true; }
        }, options);
      });
      this.message.addEventListener('input', () => { this.status.textContent = ''; }, options);
    }
    generate() {
      for (const field of this.fields) {
        field.setCustomValidity('');
        if (field.required && !field.value.trim()) field.value = '';
        if (!field.reportValidity()) return;
      }
      const values = Object.fromEntries(this.fields.map(field => [field.dataset.field, field.value.trim()]));
      const s = this.strings;
      const lines = [s.greeting, '', s.intro];
      if (values.firstname) lines.push(`${s.firstname} : ${values.firstname}`);
      lines.push('', `${s.idea} : ${values.idea}`, `${s.placement} : ${values.placement}`, `${s.size} : ${values.size}`, `${s.budget} : ${values.budget}`, `${s.ink} : ${values.ink}`);
      if (values.availability) lines.push(`${s.availability} : ${values.availability}`);
      lines.push('', s.ending);
      this.message.value = lines.join('\n');
      this.querySelector('[data-message-empty]').hidden = true;
      this.result.hidden = false;
      this.copyButton.disabled = false;
      this.generated = true;
      this.status.textContent = s.ready;
      this.message.focus({ preventScroll: true });
      this.result.scrollIntoView({ block: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    async copy() {
      if (!this.message.value.trim()) { this.status.textContent = this.strings.empty; this.message.focus(); return; }
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(this.message.value);
        this.status.textContent = this.strings.copied;
      } catch {
        this.message.focus(); this.message.select();
        this.message.setSelectionRange(0, this.message.value.length);
        this.status.textContent = this.strings.fallback;
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  }
  customElements.define('studio10-request', Studio10Request);
}

if (!customElements.get('studio10-carousel')) {
  class Studio10Carousel extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('[data-carousel-track]');
      this.slides = [...this.track.children];
      this.dots = [...this.querySelectorAll('[data-carousel-dot]')];
      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      this.counter = this.querySelector('[data-carousel-counter]');
      this.index = 0;
      this.querySelector('[data-carousel-controls]').hidden = this.slides.length < 2;
      this.prev.addEventListener('click', () => this.go(this.index - 1), options);
      this.next.addEventListener('click', () => this.go(this.index + 1), options);
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i), options));
      this.track.addEventListener('keydown', event => {
        let target;
        if (event.key === 'ArrowLeft') target = this.index - 1;
        if (event.key === 'ArrowRight') target = this.index + 1;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = this.slides.length - 1;
        if (target !== undefined) { event.preventDefault(); this.go(target); }
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const width = this.track.clientWidth;
          if (width) { this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width))); this.update(); }
        });
      }, { ...options, passive: true });
      this.resize = new ResizeObserver(() => {
        if (this.track.clientWidth) this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' });
      });
      this.resize.observe(this.track);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.indexOf(event.target.closest('figure'));
        if (index >= 0) this.go(index);
      }, options);
      this.update();
    }
    go(index) {
      this.index = Math.max(0, Math.min(this.slides.length - 1, index));
      this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      this.update();
    }
    update() {
      this.prev.disabled = this.index === 0;
      this.next.disabled = this.index === this.slides.length - 1;
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
      this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; this.resize?.disconnect(); cancelAnimationFrame(this.frame); }
  }
  customElements.define('studio10-carousel', Studio10Carousel);
}


if (!customElements.get('studio10-gift')) customElements.define('studio10-gift', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return; this.ready = true;
    const input = this.querySelector('[type=number]'), custom = this.querySelector('[data-gift-custom]'), total = this.querySelector('[data-gift-total]'), error = this.querySelector('[data-gift-error]');
    const email = this.querySelector('[data-gift-email]'), emailError = this.querySelector('[data-gift-email-error]');
    let emailTouched = false;
    const validateEmail = () => {
      const invalid = !email.validity.valid;
      emailError.hidden = !emailTouched || !invalid;
      email.setAttribute('aria-invalid', String(emailTouched && invalid));
    };
    email.addEventListener('blur', () => {email.value = email.value.trim(); emailTouched = true; validateEmail();});
    email.addEventListener('input', validateEmail);
    const update = () => {
      const choice = this.querySelector('[type=radio]:checked').value;
      const free = choice === 'custom'; custom.hidden = !free; input.disabled = !free;
      const amount = free ? input.valueAsNumber : Number(choice);
      const valid = Number.isFinite(amount) && amount > 0 && (!free || input.validity.valid);
      error.hidden = !free || valid || input.value === '';
      input.setAttribute('aria-invalid', String(free && !valid && input.value !== ''));
      total.textContent = valid ? new Intl.NumberFormat('fr-FR', {style:'currency',currency:'EUR'}).format(amount) : '—';
    };
    this.addEventListener('change', update); input.addEventListener('input', update); update();
  }
});

if (!customElements.get('studio10-shop-tabs')) customElements.define('studio10-shop-tabs', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return; this.ready = true;
    const list = this.querySelector('[role=tablist]');
    const tabs = [...list.querySelectorAll('[role=tab]')];
    const panels = [...this.querySelectorAll('[data-shop-panel]')];
    const select = (index, focus = false) => {
      tabs.forEach((tab, i) => {
        const active = index === i;
        tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
        panels[i].hidden = !active;
      });
      if (focus) tabs[index].focus();
    };
    panels.forEach((panel, i) => {panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',tabs[i].id);panel.tabIndex = 0;});
    tabs.forEach((tab, i) => tab.addEventListener('click', () => select(i)));
    list.addEventListener('keydown', event => {
      const i = tabs.indexOf(event.target); if (i < 0) return;
      let next;
      if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else return;
      event.preventDefault(); select(next, true);
    });
    select(location.hash === '#s10-shop-clothes' ? tabs.findIndex(tab => tab.getAttribute('aria-controls') === 's10-shop-clothes') : 0); list.hidden = false;
  }
});

  } catch(e) { console.error(e); }
})();
})();
